import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import LanguageWrapper from "../components/LanguageWrapper";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Blog from "../pages/blog/page";
import WellnessRemoteWork from "../pages/blog/wellness-remote-work/page";
import ErikaDelaVegaPortfolio from "../pages/portfolio/erika-de-la-vega/page";
import IsmaelCalaPortfolio from "../pages/portfolio/ismael-cala/page";
import MiaAstralPortfolio from "../pages/portfolio/mia-astral/page";
import FotoAhoraPortfolio from "../pages/portfolio/foto-ahora/page";
import PFSRealtyPortfolio from "../pages/portfolio/pfs-realty/page";
import NawisPortfolio from "../pages/portfolio/nawis/page";
import YogurtBoomPortfolio from "../pages/portfolio/yogurt-boom/page";
import RunAHRPortfolio from "../pages/portfolio/runahr/page";
import WideAnglePortfolio from "../pages/portfolio/wide-angle/page";
import CachaloYGanaPortfolio from "../pages/portfolio/cachalo-y-gana/page";
import XcapePortfolio from "../pages/portfolio/xcape/page";
import ContactPage from "../pages/contact/page";
import ServicesPage from "../pages/services/page";

const routes: RouteObject[] = [
  {
    path: "/:lang",
    element: <LanguageWrapper />,
    children: [
      {
        path: "",
        element: <Home />,
      },
      {
        path: "blog",
        element: <Blog />,
      },
      {
        path: "blog/wellness-remote-work",
        element: <WellnessRemoteWork />,
      },
      {
        path: "portfolio/erika-de-la-vega",
        element: <ErikaDelaVegaPortfolio />,
      },
      {
        path: "portfolio/ismael-cala",
        element: <IsmaelCalaPortfolio />,
      },
      {
        path: "portfolio/mia-astral",
        element: <MiaAstralPortfolio />,
      },
      {
        path: "portfolio/foto-ahora",
        element: <FotoAhoraPortfolio />,
      },
      {
        path: "portfolio/pfs-realty",
        element: <PFSRealtyPortfolio />,
      },
      {
        path: "portfolio/nawis",
        element: <NawisPortfolio />,
      },
      {
        path: "portfolio/yogurt-boom",
        element: <YogurtBoomPortfolio />,
      },
      {
        path: "portfolio/runahr",
        element: <RunAHRPortfolio />,
      },
      {
        path: "portfolio/wide-angle",
        element: <WideAnglePortfolio />,
      },
      {
        path: "portfolio/cachalo-y-gana",
        element: <CachaloYGanaPortfolio />,
      },
      {
        path: "portfolio/xcape",
        element: <XcapePortfolio />,
      },
      {
        path: "contact",
        element: <ContactPage />,
      },
      {
        path: "services",
        element: <ServicesPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
  {
    path: "/",
    element: <Navigate to="/es" replace />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
